import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import {
  Breakpoints,
  ColorProfiles,
  Components, FontFamily, FontSize, ThemeProps as Prop,
} from '@powdr/constants';
import {
  componentColor, getFontStyles, themeUtil,
} from '@powdr/utils';

const CPNT = Components.CONTENT_CAROUSEL;

const StyledSlideText = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  padding: 15px;
  margin: 20px;
  background-color: ${({ $colorProfile, $componentTheme }) => (($componentTheme) ? componentColor(Prop.BTN_BG, $componentTheme) : themeUtil(Prop.BTN_BG, CPNT, $colorProfile))};

  ${Breakpoints.mobile(css`
    padding: 10px;
    margin: 10px;
  `)}
`;

const SlideTextWrapper = styled.div``;

const SlideTextInner = styled.div`
  color: ${({ $colorProfile, $componentTheme }) => (($componentTheme) ? componentColor(Prop.BTN_TXT, $componentTheme) : themeUtil(Prop.BTN_TXT, CPNT, $colorProfile))};
  ${() => getFontStyles(FontFamily.SECONDARY_FONT, FontSize.MED40, undefined, undefined)};
  line-height: 1.1;

  ${Breakpoints.mobile(css`
    ${() => getFontStyles(FontFamily.SECONDARY_FONT, FontSize.REG50, undefined, undefined)};
  `)}
`;

export const SlideText = ({
  className = '',
  colorProfile = ColorProfiles.BASE,
  componentTheme = null,
  children,
}) => (
  (children) && (
    <StyledSlideText className={className}>
      <SlideTextWrapper $colorProfile={colorProfile} $componentTheme={componentTheme}>
        <SlideTextInner $colorProfile={colorProfile} $componentTheme={componentTheme}>
          {children}
        </SlideTextInner>
      </SlideTextWrapper>
    </StyledSlideText>
  )
);

SlideText.propTypes = {
  className: PropTypes.string,
  colorProfile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  componentTheme: PropTypes.oneOf(Object.values(Components)),
  children: PropTypes.node,
};
